import NgpTextField from '../../../form/NgpTextField';
import { IPADDRESS_FIELD, LABEL_IP_ADDRESS } from '../InfrastructureConstants';
import { DescriptionField, PollingStatusField } from '../InfrastructureFieldComponents';

const IP_ADDRESS_SIZE = 40;
const IP_ADDRESS_MAX_LENGTH = 128;

/**
 * Displays common fields for virtual machines and hypervisors
 * Includes IP address (read-only), polling status, and description
 */
const VirtualCommonFields = () => {
    return (
        <>
            <NgpTextField
                fieldName={IPADDRESS_FIELD}
                label={LABEL_IP_ADDRESS}
                inputProps={{ size: IP_ADDRESS_SIZE, maxLength: IP_ADDRESS_MAX_LENGTH }}
                disabled
            />
            <PollingStatusField />
            <DescriptionField />
        </>
    );
};

export default VirtualCommonFields;
